import {isAxiosError} from 'axios';
import {INN_ALREADY_EXISTS_ERROR} from 'features/registration';

export const revokePreviewUrl = (previewUrl: string | null) => {
	if (previewUrl?.startsWith('blob:')) {
		URL.revokeObjectURL(previewUrl);
	}
};

/** PATCH /identification/inn: `{errors: string[]}`; без текста — 400 трактуем как «ИНН занят». */
export const getInnApiErrorMessage = (error: unknown): string => {
	if (isAxiosError<{errors?: string[]}>(error)) {
		const messages = error.response?.data?.errors?.filter((message) => message.trim().length > 0) ?? [];

		if (messages.length > 0) {
			return messages.join('. ');
		}

		if (error.response?.status === 400) {
			return INN_ALREADY_EXISTS_ERROR;
		}
	}

	return 'Не удалось сохранить ИНН';
};

export const getRegistrationApiErrorMessage = (error: unknown, fallback: string): string => {
	if (isAxiosError<{errors?: string[]}>(error)) {
		return error.response?.data?.errors?.[0] ?? fallback;
	}

	return fallback;
};

const SNILS_ALREADY_EXISTS_API_ERROR = 'Snils already exists';

const translateSnilsApiError = (message: string): string => {
	if (message === SNILS_ALREADY_EXISTS_API_ERROR) {
		return 'СНИЛС уже существует';
	}

	return message;
};

/** PATCH /identification/snils: `{errors: string[]}`. */
export const getSnilsApiErrorMessage = (error: unknown): string => {
	if (isAxiosError<{errors?: string[]}>(error)) {
		const messages =
			error.response?.data?.errors
				?.map((message) => message.trim())
				.filter((message) => message.length > 0)
				.map(translateSnilsApiError) ?? [];

		if (messages.length > 0) {
			return messages.join('. ');
		}
	}

	return 'Не удалось сохранить СНИЛС';
};
